import React from "react";
import { DefaultButton, Modal, Label, Stack } from "@fluentui/react";
import { ModalRenounceAccessProps } from "@/screen/Identities/Interfaces/IdentitiesMainScreenInterfaces";
import { contentStyles, styleLabel, styleDefButton, styleCancelButton } from "@/screen/Identities/Styles/IdentitiesMainScreenStyles";

const ModalRenounceAccess: React.FC<ModalRenounceAccessProps> = ({isOpen, identityFullName, errorMessage, isSubmitting, onConfirm, onCancel}) =>
{
    const showError = Boolean(errorMessage);
    return(
        <Modal isOpen={isOpen}>
            <div className={contentStyles.header}>
                <Label styles={styleLabel}>Renunciar al acceso</Label>
            </div>
            <div className={contentStyles.body}>
                <p>
                    ¿Estás seguro de que deseas renunciar al acceso del interviniente{" "}<br />
                    <strong>{identityFullName}</strong>?
                </p>
                <p style={{marginTop: "10px", color: "#95a0a1", fontSize: "14px"}}>
                    Perderás el acceso a la información de este interviniente.
                </p>
                {showError &&
                (
                    <p role="alert"
                        style={
                        {
                            marginTop: "14px",
                            padding: "10px 12px",
                            borderRadius: "4px",
                            backgroundColor: "rgba(204, 33, 79, 0.08)",
                            color: "#a4262c",
                            cursor: "default",
                            fontSize: "14px",
                            lineHeight: "1.4",
                        }}
                    >
                        {errorMessage}
                    </p>
                )}
            </div>
            <Stack.Item style={{display: "flex", justifyContent: "center", padding: "10px", gap: "10px"}}>
                <DefaultButton styles={styleCancelButton} onClick={onCancel} disabled={isSubmitting}>
                    Cancelar
                </DefaultButton>
                <DefaultButton styles={styleDefButton} onClick={onConfirm} disabled={isSubmitting} text={isSubmitting ? "Enviando…" : "Renunciar"} />
            </Stack.Item>
        </Modal>
    );
};

export default ModalRenounceAccess;